import React from 'react'
import set from 'lodash/set'

import { ComponentError } from '../../utils/errors'
import createLog from '../../utils/createLog'
// TODO Fix eslint
const enhance = (componentDescription: string) => (ComposedComponent: any) => {
  class ErrorHandler extends React.Component<any, any> {
    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(error: any, info: any) {
      const logError: any = {
        ...info,
        message: error.message || '',
        name: `${error.name} (${componentDescription})`,
        stack: error.stack,
      }
      createLog({ error: logError })

      // eslint-disable-next-line no-param-reassign
      error.component = componentDescription

      const componentError = new ComponentError(info, error)
      set(componentError, 'stack.component', componentDescription)
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  return ErrorHandler
}

export default enhance
